import React, { useState } from 'react';
import { useAuthUser } from '../../hooks/useAuthUser';
import Home from '../../pages/Home/Home';
import LandingPage from '../../pages/LandingPage/LandingPage';
import { readSessionAuthHint } from '../../utils/sessionAuthHint';
import RootReturningPlaceholder from '../RootReturningPlaceholder/RootReturningPlaceholder';

/**
 * `/` resolves to Home vs landing without forcing a marketing flash for browsers
 * that recently had an active Calcium session — see sessionAuthHint + AppContent sync.
 */
const RootLandingHome = () => {
	const { user, isLoaded } = useAuthUser();
	const [likelyReturningSession] = useState(() => readSessionAuthHint());

	if (!isLoaded && likelyReturningSession) {
		return <RootReturningPlaceholder />;
	}
	if (!isLoaded) {
		return <LandingPage />;
	}
	return user ? <Home /> : <LandingPage />;
};

export default RootLandingHome;
